import { useStats } from 'react-instantsearch';
import React, {useEffect} from "react";
const Stats = () => {
    const {nbHits} = useStats();
    return <span>{nbHits} {`Résults`}</span>;
};
export default Stats;
